import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { Observable, Subject, map, tap } from 'rxjs';
import { AllStatus } from '../../../core/services/status/all-status';

export interface IRole{
  rq_id: number,
  name: string,
  is_custom: boolean,
  is_newbie: boolean,
  type: string,
  icon: string,
  data: {
    humman_description:{
      title: string,
      text: string,
      [propName: string]: any
    },
    questionnaire: Array<number>,
    [propName: string]: any
  },
  [propName: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class ListRoles {
  

  http = inject(HttpClient);
  backend = inject(BackendService);
  readonly rolesUpdated$ = new Subject<void>();
  roles: Array<IRole>;
  allStatus = inject(AllStatus);

  constructor() { }

  getAllRoles(){
    const isQuest = !!sessionStorage.getItem("questsAll");
    if(isQuest){
      this.roles = JSON.parse(sessionStorage.getItem("questsAll") as string); 
      this.rolesUpdated$.next();
      this.allStatus.setSelectRQ(this.roles[0].rq_id);
      this.allStatus.setLoadRQ(true);
    }else{
      this.roles = [];
      this.http.get(`${this.backend.getApiUrl()}/roles`).pipe(
        tap( (jsonQuest: any) => {
          this.roles = jsonQuest.roles;
          this.saveStorage(); 
        })
      ).subscribe();
    }
  }

  getRolesForLanguageChange(): Observable<void>{
    return this.http.get<{roles: Array<IRole>}>(`${this.backend.getApiUrl()}/roles`).pipe(
      tap(({roles}) => {
        this.roles = roles;
        sessionStorage.setItem('questsAll', JSON.stringify(this.roles));
        this.allStatus.setSelectRQ(this.roles[0].rq_id);
        this.allStatus.setLoadRQ(true);
        this.rolesUpdated$.next();
      }),
      map(() => undefined)
    );
  }

  saveStorage(){
    sessionStorage.setItem('questsAll', JSON.stringify(this.roles));
    this.allStatus.setSelectRQ(this.roles[0].rq_id);
    this.allStatus.setLoadRQ(true);
    this.allStatus.setDisplayProgressSpinner(false);
    this.rolesUpdated$.next();
  }

  roleInfo(rq_id: number) {
    return this.http.get(`${this.backend.getApiUrl()}/roles/${rq_id}`).pipe(
      tap( (result: any) => sessionStorage.setItem("QuestInfo", JSON.stringify(result.readrole)) )
    );
  }

  findRole(id: number):IRole{
    return this.roles.find((item: IRole) => item.rq_id === id) as IRole;
  }
  
}
